import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { IOuter } from '../EmptyState.types';

export const TrashTitle: FC<IOuter> = () => <FormattedMessage id="empty-state.trash-title" />;
